import { FC } from 'react'

import { AppConfig } from 'shared/types/app'

interface AppModalsProps {
  appConfig: AppConfig
}

export const AppModals: FC<AppModalsProps> = ({ appConfig }) => {
  if (!appConfig.modals?.length) return null

  return (
    <>
      {appConfig.modals.map((Modal, index) => (
        <Modal key={`${appConfig.id}-modal-${index}`} />
      ))}
    </>
  )
}
